<template>
    <a
        :class="['house-contact', { isDisabled: cardData.status === 4 }]"
        v-if="cardData"
        data-spm-data="t"
        :data-spm-content="dataSpmContent"
    >
        <div :class="['house-contact-container']">
            <div class="left">
                <img class="sales-span" :src="cardData.fields.image" />
            </div>
            <div class="left sales-info">
                <div>
                    <p class="title">{{ cardData.fields.title }}</p>
                </div>
                <div class="bottomContainer">
                    <div class="leftContainer">
                        <p class="location">{{ cardData.fields.address }}</p>
                        <p class="desc">{{ cardData.fields.area }}</p>
                        <p class="price">{{ cardData.fields.price }}</p>
                    </div>
                    <div class="btnContainer">
                        <div
                            class="contact-sales"
                            @click="showMessageBox"
                            v-if="cardData.status !== 4"
                        >
                            <i class="icon icon-phone"></i>
                            <a
                                class="contact-us"
                                :href="fullTel"
                                v-if="isIos && hasExtNum"
                                @click="callPhone"
                                >联系售楼处</a
                            >
                            <span
                                class="contact-us"
                                v-else-if="!isIos && hasExtNum"
                                @click="callPhone"
                                >联系售楼处</span
                            >
                            <a
                                class="contact-us"
                                :href="tel"
                                v-else
                                @click="callPhone"
                                >联系售楼处</a
                            >
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="left house-info">
          <p class="title">{{ cardData.fields.title }}</p>
          <p class="desc"
            v-if="cardData.fields.desc">
            {{ cardData.fields.desc }}
          </p>
          <p class="place">{{ cardData.fields.assemblyAddress }}</p>
          <p class="update">{{ cardData.fields.deadlineString }}</p>
          <p class="suprise">{{ cardData.fields.remark }}</p>
        </div> -->
            <div style="clear: both;"></div>
        </div>
        <div class="message-layer" v-show="visible && hasExtNum && !isIos">
            <div class="message-box">
                <div class="message-content">
                    <p class="remind">请您记住以下分机号，接通后输入</p>
                    <div class="tel-num">{{ cardData.fields.extPhoneNum }}</div>
                </div>
                <footer>
                    <div class="btn cancel-btn" @click="handleCancel">
                        {{ cancelTxt }}
                    </div>
                    <a class="btn confirm-btn" :href="tel" @click="alertCall">{{
                        confirmTxt
                    }}</a>
                </footer>
            </div>
        </div>
        <card-bottom :data="cardData"></card-bottom>
    </a>
</template>

<script>
import cardBottom from "./../common/cardBottom.vue";
import Supporter from "../../../_utils/supporter";
export default {
    components: {
        cardBottom,
    },
    data() {
        return {
            //分机号弹框是否显示
            visible: false,

            cancelTxt: "取消",
            confirmTxt: "拨号",

            isIos: Supporter.os.ios,
        };
    },
    computed: {
        cardData() {
            return this.articleData;
        },
        hasExtNum() {
            return this.cardData.fields && this.cardData.fields.extPhoneNum;
        },
        phoneNum() {
            return this.cardData.fields.phoneNum;
        },
        fullTel() {
            return `tel:${this.phoneNum},${this.hasExtNum}`;
        },
        tel() {
            return `tel:${this.phoneNum}`;
        },
        cardUuid() {
            return this.uuid;
        },
        dataSpmContent() {
            return `||${this.cardUuid}||`;
        },
    },

    mounted() {},
    methods: {
        showMessageBox() {
            this.visible = true;
        },
        handleCancel() {
            this.visible = false;
        },
        callPhone() {
            this.sendAction("8643");
        },
        alertCall() {
            this.sendAction("8644");
        },
        sendAction(acode) {
            if (
                window.sohuSpm &&
                typeof window.sohuSpm.sendAction === "function"
            ) {
                window.sohuSpm.sendAction({
                    acode: acode,
                    clkParam: `accountId:${window.cfgs.media_id}; articleId:${window.cfgs.newsId};cardId:${this.cardUuid}`,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../../less/base/mixins.less";
#articleContent {
    .house-contact {
        width: 100%;
        display: inline-block;
        margin-bottom: 40px;
    }
    .house-contact-container {
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 229, 229, 1);
        display: flex;
        .left {
            .sales-span {
                width: 206px;
                height: 206px;
                margin-right: 20px;
                margin-bottom: 0;
            }
        }
        .sales-info {
            padding: 24px 20px 11px 0;
            .bottomContainer {
                display: flex;
                align-items: flex-end;
                .leftContainer {
                    width: 250px;
                    flex: 1;
                    .location,
                    .desc {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        margin-bottom: 7px;
                        font-size: 28px !important; /*px*/
                        line-height: 38px !important; /*px*/
                        color: #a4a4a4;
                    }
                    .price {
                        margin-bottom: 0;
                        height: 38px; /*px*/
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 32px !important; /*px*/
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: rgba(249, 74, 37, 1);
                        line-height: 38px !important; /*px*/
                    }
                }
                .btnContainer {
                    display: flex;
                    flex-direction: column-reverse;
                    margin-right: -30px;
                    .contact-sales {
                        margin-bottom: 10px;
                        display: flex;
                        padding: 0px 24px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: #f94a25;
                        line-height: 36px;
                        justify-content: center;
                        align-items: center;
                        border-radius: 1rem; /*px*/
                        background: rgba(245, 245, 245, 1);
                        font-size: 26px !important; /*px*/
                        .icon-phone {
                            height: 56px;
                            margin-right: 6px;
                            line-height: 56px;
                            font-size: 20px; /*px*/
                        }
                        .contact-us {
                            font-size: 26px !important;
                            color: #ff0000;
                        }
                    }
                }
            }
            .title {
                width: 420px;
                margin-bottom: 12px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-weight: 500;
                height: 32px; /*px*/
                line-height: 32px; /*px*/
                font-size: 32px !important; /*px*/
                color: #3c3c3d;
            }
        }
    }
    .message-layer {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 10000;
        .message-box {
            position: absolute;
            top: 488px;
            left: 50%;
            width: 620px;
            height: 361px;
            border-radius: 1rem;
            transform: translate(-50%);
            background: #ffffff;
            .message-content {
                box-sizing: border-box;
                height: 251px;
                padding-top: 41px;
                .remind {
                    display: block;
                    height: 30px;
                    margin-bottom: 40px;
                    text-align: center;
                    font-size: 30px !important; /*px*/
                    color: #191919;
                }
                .tel-num {
                    display: flex;
                    width: 275px;
                    height: 100px;
                    margin-left: 172px;
                    align-items: center;
                    justify-content: center;
                    font-size: 44px; /*px*/
                    background: #fff4f4;
                    color: #ff0000;
                }
            }
            footer {
                display: flex;
                height: 109px;
                border-top: 1px solid #f0f0f0; /*no*/
                text-align: center;
                font-size: 30px; /*px*/
                color: #999999;
                .btn {
                    flex: 1;
                    padding-top: 40px;
                }
                .confirm-btn {
                    border-left: 1px solid #f0f0f0; /* no */
                    color: #191919;
                }
            }
        }
    }
}
.isDisabled {
    opacity: 0.5;
}
</style>
